(function () {
  var root = document.querySelector('.md-rt');
  var KLAVIYO_COMPANY_ID = root ? root.getAttribute('data-klaviyo-id') : '';
  var STORAGE_KEY = 'md_retractation_recap';
  var form = document.getElementById('md-rt-form');
  if (!form) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function recapHtml(d) {
    var rows = [];
    if (d.reference) rows.push(['Référence', d.reference]);
    if (d.date_heure) rows.push(['Date et heure', d.date_heure + ' (heure de Paris)']);
    rows.push(['Nom', d.prenom + ' ' + d.nom]);
    rows.push(['E-mail', d.email]);
    rows.push(['Commande concernée', d.numero_commande]);
    rows.push(['Articles concernés', d.articles || 'Toute la commande']);
    if (d.message) rows.push(['Message', d.message]);
    return '<dl>' + rows.map(function (r) {
      return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>';
    }).join('') + '</dl>';
  }

  function declaration(d) {
    return '« Je vous notifie par la présente ma rétractation du contrat portant sur la commande ' +
      d.numero_commande + (d.articles ? ' (' + d.articles + ')' : '') + '. »';
  }

  /* Page de confirmation après envoi */
  var done = document.getElementById('md-rt-done');
  if (done) {
    try {
      var saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (saved) {
        var box = document.getElementById('md-rt-done-recap');
        box.innerHTML = recapHtml(saved) + '<p class="md-rt__declaration">' + esc(declaration(saved)) + '</p>';
        box.hidden = false;
      }
    } catch (e) {}
    done.focus();
    var printBtn = document.getElementById('md-rt-print');
    if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
    return;
  }

  var step1 = document.getElementById('md-rt-step1');
  var step2 = document.getElementById('md-rt-step2');
  var f = {
    prenom: document.getElementById('md-rt-firstname'),
    nom: document.getElementById('md-rt-lastname'),
    email: document.getElementById('md-rt-email'),
    numero_commande: document.getElementById('md-rt-order'),
    articles: document.getElementById('md-rt-items'),
    message: document.getElementById('md-rt-message')
  };

  function data() {
    var d = {};
    Object.keys(f).forEach(function (k) { d[k] = f[k].value.trim(); });
    return d;
  }

  function valid(d) {
    var okMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email);
    return d.prenom && d.nom && d.numero_commande && okMail;
  }

  document.getElementById('md-rt-next').addEventListener('click', function () {
    var d = data();
    var err = document.getElementById('md-rt-step1-error');
    if (!valid(d)) {
      err.hidden = false;
      Object.keys(f).forEach(function (k) {
        if (f[k].required) f[k].setAttribute('aria-invalid', f[k].value.trim() ? 'false' : 'true');
      });
      return;
    }
    err.hidden = true;
    document.getElementById('md-rt-recap').innerHTML = recapHtml(d);
    document.getElementById('md-rt-declaration').textContent = declaration(d);
    step1.hidden = true;
    step2.hidden = false;
    step2.focus();
    step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.getElementById('md-rt-back').addEventListener('click', function () {
    step2.hidden = true;
    step1.hidden = false;
    f.prenom.focus();
  });

  function parisNow() {
    var now = new Date();
    var date = now.toLocaleDateString('fr-FR', { timeZone: 'Europe/Paris', day: '2-digit', month: '2-digit', year: 'numeric' });
    var time = now.toLocaleTimeString('fr-FR', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit' });
    var parts = date.split('/');
    var stamp = parts[2] + parts[1] + parts[0] + '-' + time.replace(':', '');
    return { label: date + ' à ' + time, stamp: stamp, iso: now.toISOString() };
  }

  var sending = false;
  document.getElementById('md-rt-confirm').addEventListener('click', function () {
    if (sending) return;
    sending = true;
    var btn = this;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Envoi en cours…';

    var d = data();
    var t = parisNow();
    d.reference = 'RT-' + t.stamp + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    d.date_heure = t.label;

    document.getElementById('md-rt-name').value = d.prenom + ' ' + d.nom;
    document.getElementById('md-rt-ref').value = d.reference;
    document.getElementById('md-rt-date').value = d.date_heure + ' (heure de Paris)';
    document.getElementById('md-rt-body').value =
      'DEMANDE DE RÉTRACTATION\n' + declaration(d) + '\n\nRéférence : ' + d.reference +
      '\nDate et heure : ' + d.date_heure + ' (heure de Paris)' +
      '\nNom : ' + d.prenom + ' ' + d.nom + '\nE-mail : ' + d.email +
      '\nCommande : ' + d.numero_commande + '\nArticles : ' + (d.articles || 'Toute la commande') +
      (d.message ? '\nMessage : ' + d.message : '');

    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(d)); } catch (e) {}

    function submitForm() {
      HTMLFormElement.prototype.submit.call(form);
    }

    if (!KLAVIYO_COMPANY_ID || !window.fetch) { submitForm(); return; }

    var payload = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            reference: d.reference,
            date_heure: d.date_heure,
            prenom: d.prenom,
            nom: d.nom,
            email: d.email,
            numero_commande: d.numero_commande,
            articles: d.articles,
            message: d.message,
            source: 'page rétractation'
          },
          time: t.iso,
          unique_id: d.reference,
          metric: { data: { type: 'metric', attributes: { name: 'Rétractation demandée' } } },
          profile: { data: { type: 'profile', attributes: { email: d.email, first_name: d.prenom, last_name: d.nom } } }
        }
      }
    };

    var controller = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, 6000);
    fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
      keepalive: true
    })
      .catch(function () {})
      .then(function () { clearTimeout(timer); submitForm(); });
  });
})();